import { Form, FormProps } from "@/components/form";
import { Typography } from "@mui/material";
import { z } from "zod/v4";

export const editUsuarioPasswordFormSchema = z.object({
    newPassword: z.string().min(6, { message: "La contraseña debe tener 6 o más carácteres" })
})

export default function EditUsuarioPasswordForm({
    form,
    ...props
}: FormProps<z.infer<typeof editUsuarioPasswordFormSchema>>) {
    return <Form form={form} gap={3} {...props}>
        <Typography component={"h2"} variant="h6">Ingrese la Nueva Contraseña</Typography>
        <Form.PasswordField name="newPassword" label="Nueva Contraseña" />
        <Form.SubmitButton>Editar</Form.SubmitButton>
    </Form>
}